import AxiosClient from '../../../../../functional/Axios/AxiosClient';

export function getBranchesAll() {
  return AxiosClient.get('/root/branch')
    .then((data) => data)
    .catch((error) => error);
}
